import { useState } from 'react';
import { Rocket, DollarSign, TrendingUp, Sparkles, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import AffiliateJoinDialog from './AffiliateJoinDialog';

const AffiliateProgram = () => {
  const [open, setOpen] = useState(false);

  const features = [
    {
      icon: <DollarSign className="w-6 h-6 text-white" />,
      title: 'Exclusive Rewards',
      description: 'Earn commissions for every new user you bring to the platform.',
    },
    {
      icon: <Rocket className="w-6 h-6 text-white" />,
      title: 'Early Payouts',
      description: 'Get your earnings faster with our streamlined payout system.',
    },
    {
      icon: <TrendingUp className="w-6 h-6 text-white" />,
      title: 'Grow Together',
      description: 'We provide you with the tools and support to succeed.',
    },
  ];

  return (
    <section id="affiliate" className="py-20 sm:py-32 bg-black text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/20 text-xs font-semibold mb-5">
            <Sparkles className="w-3.5 h-3.5" /> AFFILIATE PARTNERSHIPS
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight">
            Earn commissions building the creative economy
          </h2>
          <p className="mt-5 text-lg text-gray-400">
            Exclusively for creators and venues. Refer, earn, repeat.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Button
              onClick={() => setOpen(true)}
              size="lg"
              className="h-16 px-12 text-lg sm:text-xl bg-white text-black hover:bg-gray-100 font-extrabold rounded-full shadow-[0_0_50px_rgba(255,255,255,0.35)] hover:shadow-[0_0_70px_rgba(255,255,255,0.5)] hover:scale-[1.03] transition-all animate-fade-in"
            >
              Join the Affiliate Program <ArrowRight className="w-6 h-6 ml-3" />
            </Button>
          </div>
        </div>

        <div className="mt-20 grid sm:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {features.map((feature) => (
            <div key={feature.title} className="p-6 rounded-2xl bg-white/5 border border-white/10 hover:border-white/20 transition-colors">
              <div className="bg-white/10 w-12 h-12 flex items-center justify-center rounded-full mb-4">
                {feature.icon}
              </div>
              <h4 className="font-semibold text-lg">{feature.title}</h4>
              <p className="text-gray-400 mt-2 text-sm">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center">
        </div>
      </div>

      <AffiliateJoinDialog open={open} onOpenChange={setOpen} />
    </section>
  );
};

export default AffiliateProgram;
